// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__pcq_D-W2XnStnFOtMptWj","disabled":"style_disabled__2dICPTaeG5E5js3vmGlZbw"};